import config from '~/config';
import { SVGS } from '~/assets/assetsPath';

export const navbarMobile = [
    {
        id: 1,
        title: 'Home',
        path: config.routes.home,
        icon: [SVGS.IconHomeOn, SVGS.IconHome],
    },

    {
        id: 2,
        title: 'Service',
        path: config.routes.spa,
        icon: [SVGS.IconCollectionOn, SVGS.IconCollection],
    },
    {
        id: 3,
        title: 'Product',
        path: config.routes.products,
        icon: [SVGS.IconViewGridOn, SVGS.IconViewGrid],
    },
    {
        id: 4,
        title: 'Soi da',
        path: config.routes.topUp,
        icon: [SVGS.IconSkinOn, SVGS.IconSkin],
    },
    {
        id: 5,
        title: 'Notice',
        path: config.routes.notification,
        icon: [SVGS.IconBellOn, SVGS.IconBell],
    },
    {
        id: 6,
        title: 'Personal',
        path: config.routes.personalPage,
        icon: [SVGS.IconPersonOn, SVGS.IconPerson],
    },
];
